export default {
	DELIVERYMETHODS: 'companies/:company_id/delivery-methods/',
}